export default __webpack_public_path__ + "static/CircleSteps-a3e00a4786c841c3d001e2949b80abaa.png";